<div class="row">
     <div class="col-12">
         <div class="row justify-content-between align-items-center" id="page-title">
             <h1 class="progress-header col-12 col-lg-auto">
                 {{ 'Enroll in PSP_MAIN'  | translator:'base' }}
             </h1>
         </div>
         <div class="row mb-2">
             <span class="col-12 col-lg-auto d-flex align-items-center small">
                 <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
                 <span [innerHTML]="'Start_8-1' | translator:'base'">
                     Are you a <strong>driver</strong> looking for your own PSP record?
                 </span>
                 <a routerLink="/driver/1"
                     (click)="scrollToTop()"
                     name="Driver-record-request"
                     id="Driver-record-request"
                     [title]="'Start_8-2'  | translator:'base'" 
                     class="ms-1" 
                 >
                     <span [innerHTML]="'Start_8-2'  | translator:'base'">Access your PSP record here.</span>
                 </a>
             </span>
         </div>
         <div class="row">
             <div class="col-lg-8">
                 <div class="card shadow-sm rounded-0 border-0">
                     <div class="card-body">
                         <app-complete-bar [step]="6" [totalSteps]="19"></app-complete-bar>
                         <h2 [innerHTML]="'ISP46_1'  | translator:'base'">
                             PSP Fees
                         </h2>
                         <hr>
                         <p [innerHTML]="'ISP46_3'  | translator:'base'">
                             <strong>NIC Federal, LLC is the exclusive agent for
                                 online access to the FMCSA Pre-Employment
                                 Screening Program (PSP) records.</strong>
                         </p>
                         <p [innerHTML]="'ISP46_4'  | translator:'base'">
                             Your account will be activated immediately upon
                             approval of your agreement. You will not be
                             billed during the enrollment process.
                         </p>
                         <p [innerHTML]="'ISP46_5'  | translator:'base'">
                             1The fee structure for industry service providers
                             appears in the table below:
                         </p>
                         <table class="table table-collapsible">
                             <thead>
                                 <tr>
                                     <th scope="col" [innerHTML]="'ISP46_6'  | translator:'base'" style="width: 15%;">
                                         Account Type
                                     </th>
                                     <th scope="col" [innerHTML]="'ISP46_7'  | translator:'base'" style="width: 15%;">
                                         Subscription Fee
                                     </th>
                                     <th scope="col" [innerHTML]="'ISP46_8'  | translator:'base'" style="width: 20%;">
                                         Transaction&nbsp;Fee&#42;
                                     </th>
                                     <th scope="col" [innerHTML]="'ISP46_9'  | translator:'base'" style="width: 18%;">
                                         Billing
                                     </th>
                                 </tr>
                             </thead>
                             <tbody>
                                 <tr>
                                     <td class="bold">
                                         <span class="cell-label" [innerHTML]="'ISP46_6'  | translator:'base'">Account Type</span>
                                         <span [innerHTML]="'ISP46_10'  | translator:'base'">
                                             Industry Service Provider
                                         </span>
                                     </td>
                                     <td>
                                         <span class="cell-label" [innerHTML]="'ISP46_7'  | translator:'base'">Subscription Fee</span>
                                         <span [innerHTML]="'ISP46_11'  | translator:'base'">                                
                                             $100 annually, limited to 10 users
                                         </span>
                                     </td>
                                     <td>
                                         <span class="cell-label" [innerHTML]="'ISP46_8'  | translator:'base'">Transaction&nbsp;Fee&#42;</span>
                                         <span [innerHTML]="'ISP46_12'  | translator:'base'">                
                                             <!-- Transaction fee details here -->
                                         </span>
                                     </td>                                    
                                     <td>
                                         <span class="cell-label" [innerHTML]="'ISP46_9'  | translator:'base'">Billing</span>                            
                                         <span [innerHTML]="'ISP46_13'  | translator:'base'">    
                                             <!-- Billing details here -->
                                         </span>
                                     </td>
                                 </tr>
                             </tbody>
                         </table>
                         <p class="fw-bold mb-0" [innerHTML]="'ISP46_14'  | translator:'base'">&#42;Quantity discounts are available for simultaneous record requests.</p>
                         <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                             <div class="btn-group" role="group">
                                 <button 
                                    routerLink="/signup/12"
                                    class="btn btn-primary btn-strong"
                                    (click)="scrollToTop()"
                                    [title]="'PrimaryContact'  | translator:'base'"
                                    name="companyNext9"
                                    id="companyNext9"
                                 >
                                     <span [innerHTML]="'Continue'  | translator:'base'">Continue</span>
                                     <span class="sr-only">&nbsp;</span>
                                     <span class="sr-only" [innerHTML]="'PrimaryContact'  | translator:'base'">Primary Contact</span>
                                 </button>
                             </div>
                             <div class="btn-group" role="group">
                                 <button routerLink="/signup/7"
                                     class="btn btn-outline-primary"
                                     [title]="'CompanyInfo'  | translator:'base'"
                                     name="companyBack9"
                                     id="companyBack9"
                                 >
                                     <span [innerHTML]="'Back'  | translator:'base'">Back</span>
                                     <span class="sr-only" [innerHTML]="'CompanyInfo'  | translator:'base'">Company Info</span>
                                 </button>
                                 <button routerLink="/" tag="button" class="btn btn-light"
                                     (click)="scrollToTop()"
                                     name="companyCancel9"
                                     id="companyCancel9"
                                     [innerHTML]="'Cancel'  | translator:'base'"
                                     [title]="'Cancel'  | translator:'base'"
                                 >Cancel
                                 </button>
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
             <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="2"
                    [pageType]="enrollmentService.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
         </div>
     </div>
    <app-spinner
        [isLoading] = isLoading
    ></app-spinner>
 </div>
 
